import RouteTemplate from 'ember-route-template';
import { htmlSafe } from '@ember/template';

export default RouteTemplate(
  <template>
    <section class="pd-guide-detail">
      <div class="pd-guide-detail__container">
        <a class="pd-best-for__back" href="/glossary">← Glossary</a>
        <h1 class="pd-guide-detail__title">{{@controller.model.title}}</h1>
    
        {{#if @controller.model.publishedLabel}}
          <p class="pd-guide-detail__meta">
            <span>Updated {{@controller.model.publishedLabel}}</span>
            <span class="pd-guide-detail__difficulty">{{@controller.model.freshness}}</span>
          </p>
        {{/if}}
    
        <div class="pd-guide-detail__content">
          {{htmlSafe @controller.model.excerpt}}
        </div>
    
        {{#if @controller.model.relatedComparisons.length}}
          <div class="pd-guide-detail__related">
            <h3 class="pd-best-for__section-title">Related Comparisons</h3>
            <div class="pd-best-for__ranked-list">
              {{#each @controller.model.relatedComparisons as |c|}}
                <a class="pd-best-for__rank-item" href="/compare/{{c.slug}}">
                  <div class="pd-best-for__details">
                    <h3 class="pd-best-for__provider-name">{{c.title}}</h3>
                    {{#if c.winner_slug}}
                      <p class="pd-best-for__provider-meta">Winner: {{c.winner_slug}}</p>
                    {{/if}}
                  </div>
                  <span class="pd-best-for__cta">View →</span>
                </a>
              {{/each}}
            </div>
          </div>
        {{/if}}
      </div>
    </section>

  </template>
);
